import { UserPlatformEnum } from '../enums/platform.enum';
import { getUserPlatform } from '../utils/utils';

export const useUserPlatform = () => {
    const userPlatform: UserPlatformEnum = getUserPlatform();

    return { userPlatform };
};
